import { Token } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
const { delimited, either, map, option } = Parser;
/**
 * {@link https://drafts.csswg.org/selectors/#selector-combinator}
 *
 * @public
 */
export var Combinator;
(function (Combinator) {
    /**
     * @example div span
     */
    Combinator["Descendant"] = " ";
    /**
     * @example div \> span
     */
    Combinator["DirectDescendant"] = ">";
    /**
     * @example div ~ span
     */
    Combinator["Sibling"] = "~";
    /**
     * @example div + span
     */
    Combinator["DirectSibling"] = "+";
})(Combinator || (Combinator = {}));
/**
 * @public
 */
(function (Combinator) {
    /**
     * {@link https://drafts.csswg.org/selectors/#typedef-combinator}
     *
     * @internal
     */
    Combinator.parseCombinator = either(delimited(option(Token.parseWhitespace), either(map(Token.parseDelim(">"), () => Combinator.DirectDescendant), map(Token.parseDelim("~"), () => Combinator.Sibling), map(Token.parseDelim("+"), () => Combinator.DirectSibling))), map(Token.parseWhitespace, () => Combinator.Descendant));
})(Combinator || (Combinator = {}));
//# sourceMappingURL=combinator.js.map